import { getDefaultFieldValue } from '@modusign/react-signing';
import { SignatureType } from '@modusign/react-signing/types';

import { createAbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteSize';
import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';

export function getDefaultSignatureSize(allow: SignatureType[], scale: number): AbsoluteSize {
  const { size } = getDefaultFieldValue({
    type: 'SIGNATURE',
    config: {
      allow,
    },
  });
  return createAbsoluteSize({
    width: size.width * scale,
    height: size.height * scale,
  });
}
